import axios from 'axios';
import User from '@/domain/user/user.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class UserService {
  static searchAllUsersByProject(idProject: string): Promise<User[]> {
    return axios
      .get(`/project-api/${idProject}/users`)
      .then((response: any) => User.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static searchAllActiveUsers(): Promise<any[]> {
    return axios
      .get('/project-api/users/actives')
      .then((response: any) => User.ofList(response.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
